import React from "react";
import UnifiedServicePage from "../components/CommonSections/UnifiedServicePage";

export default function ManageSase() {
     return (
          <UnifiedServicePage
               serviceTag="managedsase_services"
               pageName="managed-sase"
               pageUrl="https://ishantechnologies.com/cybersecurity-services/managed-sase"
               parentTitle="Network Services"
               parentUrl="https://ishantechnologies.com/network-services"
               infoImageAlt="Unified Communications"
          />
     );
}
